import moment from "moment";
import qs from "qs";
import _ from 'lodash';

export default function removeStyleFromHTMLString(actualString) {
    let regex1 = /<\/?span[^>]*>/g;
    let regex2 = "style=(\"|')[^(\"|')]*(\"|')"
    let regex3 = '<' + 'font' + '[^><]*>|<.' + 'font' + '[^><]*>'
    let newString = new RegExp(`${regex1}|${regex2}|${regex3}`, "g");
    let newString2 = actualString.length > 0 && actualString && actualString.replace(newString, "")
    return newString2;
}
export const trinitySearchTrainingDateFormatter = (dateValue) => {
    if (dateValue) {
        return moment.utc(dateValue.toLocaleString()).format("DD MMM YYYY");
    } else {
        return ""
    }
};
export function compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
        }

        const varA = (typeof a[key] === 'string')
            ? a[key].toUpperCase() : a[key];
        const varB = (typeof b[key] === 'string')
            ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
            comparison = 1;
        } else if (varA < varB) {
            comparison = -1;
        }
        return (
            (order === 'desc') ? (comparison * -1) : comparison
        );
    };
}

export const tabListConstant = {
    all: "All",
    services: "Services",
    trainings: "Training",
    news: "News",
    software: "Software",
    resources: "Resources"
}

export const trinitySearchRelevanceChanges = [
    {
        key: "DatePublished desc",
        value: "Date Published"
    },
    {
        key: "Title",
        value: "Title"
    }
]

export const generalSearchRelevance = [
    {
        key: "DatePublished desc",
        value: "Date Published"
    },
    {
        key: "Title",
        value: "Title"
    }
]

export const trainingSearchRelevance = [
    {
        key: "DatePublished asc",
        value: "Training Date"
    },
    {
        key: "DisplayName",
        value: "Training Title"
    }
]

export const safeBridgeRelevance = [
    {
        key: "DatePublished asc",
        value: "Date Published"
    },
    {
        key: "Title",
        value: "Title"
    }
]

export const processParameterAndSendQuery = (staticGeneralData, searchedData) => {
    let dataObject = staticGeneralData

    if (searchedData?.sbt?.length > 0) {
        dataObject = Object.assign({}, dataObject, {"search": searchedData?.sbt});
    } else {
        dataObject = Object.assign({}, dataObject, {"search": "*"});
    }

    dataObject = Object.assign({}, dataObject, {"skip": (searchedData?.pg * 10) - 10});

    if (searchedData?.drp?.length > 0) {
        dataObject = Object.assign({}, dataObject, {"orderby": searchedData?.drp === "relevance" ? "" : searchedData?.drp})
    } else {
        dataObject = Object.assign({}, dataObject, {"orderby": ""})
    }

    if (searchedData?.ds?.length > 0) {
        let newArray = searchedData?.ds.map((outerElement, index) => {
            let key = outerElement.split("|")[0]
            let value = outerElement.split("|")[1]

            if ((searchedData?.ds.length - 1) === index) {
                return "(" + key + " eq '" + value + "')"
            } else {
                return "(" + key + " eq '" + value + "') and "
            }
        })

        let dynamicString = newArray.toString().split(",").join("")

        if (dynamicString.length === 0) {
            dynamicString = "DatePublished ge " + moment(Number.parseInt(searchedData?.rs.min)).toISOString() + " and DatePublished le " + moment(Number.parseInt(searchedData?.rs.max)).toISOString()
        } else {
            if (dynamicString.trim().endsWith("and")) {
                dynamicString = dynamicString + " DatePublished ge " + moment(Number.parseInt(searchedData?.rs.min)).toISOString() + " and DatePublished le " + moment(Number.parseInt(searchedData?.rs.max)).toISOString()
            } else {
                dynamicString = dynamicString + " and DatePublished ge " + moment(Number.parseInt(searchedData?.rs.min)).toISOString() + " and DatePublished le " + moment(Number.parseInt(searchedData?.rs.max)).toISOString()
            }
        }
        dataObject = Object.assign({}, dataObject, {"filter": dynamicString})
    }
    console.log(JSON.stringify(dataObject, null, 2));

    return dataObject
}

export const processTrainingParameterAndSendQuery = (staticGeneralData, searchedData) => {
    let dataObject = staticGeneralData

    if (searchedData?.sbt?.length > 0) {
        let newString = searchedData?.sbt
        dataObject = Object.assign({}, dataObject, {"search": newString});
    } else {
        dataObject = Object.assign({}, dataObject, {"search": "*"});
    }

    dataObject = Object.assign({}, dataObject, {"skip": (searchedData?.pg * 10) - 10});

    if (searchedData?.drp?.length > 0) {
        dataObject = Object.assign({}, dataObject, {"orderby": searchedData?.drp === "relevance" ? "" : searchedData?.drp})
    } else {
        dataObject = Object.assign({}, dataObject, {"orderby": ""})
    }

    let dynamicString = ""
    if (searchedData?.ds?.length > 0) {
        let newArray = searchedData?.ds.map((outerElement, index) => {
            let key = outerElement.split("|")[0]
            let value = outerElement.split("|")[1]

            if ((searchedData?.ds.length - 1) === index) {
                return "(" + key + " eq '" + value + "')"
            } else {
                return "(" + key + " eq '" + value + "') and "
            }
        })

        dynamicString = newArray.toString().split(",").join("")
        dataObject = Object.assign({}, dataObject, {"filter": dynamicString})
    }

    if (searchedData?.rs?.min.length > 0) {
        if (dynamicString.length === 0) {
            dynamicString = "DatePublished ge " + moment(Number.parseInt(searchedData?.rs.min)).toISOString() + " and DatePublished le " + moment(Number.parseInt(searchedData?.rs.max)).toISOString()
        } else {
            if (dynamicString.trim().endsWith("and")) {
                dynamicString = dynamicString + " DatePublished ge " + moment(Number.parseInt(searchedData?.rs.min)).toISOString() + " and DatePublished le " + moment(Number.parseInt(searchedData?.rs.max)).toISOString()
            } else {
                dynamicString = dynamicString + " and DatePublished ge " + moment(Number.parseInt(searchedData?.rs.min)).toISOString() + " and DatePublished le " + moment(Number.parseInt(searchedData?.rs.max)).toISOString()
            }
        }
        dataObject = Object.assign({}, dataObject, {"filter": dynamicString})
    }

    console.log(JSON.stringify(dataObject, null, 2));

    return dataObject
}


export const sendToURL = (historyObject, searchObject) => {
    const url = qs.stringify(searchObject);
    window.history.replaceState(null, "", `${historyObject?.location?.pathname}?${url}`)
}

export const createURLAndReturn = (searchObject) => {
    return qs.stringify(searchObject);
}

export const trinityTrainingDateFormatter = (dateValue) => {
    if (dateValue) {
        return moment(dateValue).format("DD MMM YYYY");
    } else {
        return ""
    }
};

//Only for array
export const groupBy = (data, key) => {
    return _(data)
        .groupBy(item => item[key])
        .sortBy(group => data.indexOf(group[0]))
        .value()
};
